import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
var CasePracticeInfluenceBeginComponent = (function () {
    function CasePracticeInfluenceBeginComponent(commonService, apiService, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.assetsRoute = "../../assets";
    }
    CasePracticeInfluenceBeginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.noticeShow = false;
        this.clickable = false;
        this.posterShow = false;
        // this.posterStatus = 'initPoster';
        // this.glassStatus = 'initGlass';
        this.sideTipShow = false;
        this.cardShow = false;
        this.sideTipContent = '你被任命为店长...';
        this.problemShow = false;
        var that = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/pnoStorePoint/' + this.exerciseId
        }).subscribe(function (result) {
            // 如果是访客，永远从头开始
            if (_this.userType) {
                result.status = 0;
            }
            if (result.status == 0) {
                _this.noticeShow = true;
                setTimeout(function () {
                    that.clickable = true;
                    that.step = 0;
                }, 200);
            }
            else if (result.status == 5) {
                _this.problemShow = true;
                setTimeout(function () {
                    that.clickable = true;
                    that.step = 3;
                }, 200);
            }
        });
    };
    CasePracticeInfluenceBeginComponent.prototype.screenClick = function () {
        if (!this.clickable) {
            return;
        }
        var _this = this;
        if (this.step == 0) {
            this.noticeShow = false;
            this.clickable = false;
            setTimeout(function () {
                _this.posterShow = true;
            }, 200);
            // setTimeout(function () {
            //     _this.posterStatus = 'showPoster';
            // },500);
            // setTimeout(function () {
            //     _this.posterStatus = 'smallPoster';
            //     _this.glassStatus = 'showGlass';
            // },1500);
            setTimeout(function () {
                _this.step = 1;
                _this.clickable = true;
            }, 2500);
        }
        else if (this.step == 1) {
            this.clickable = false;
            this.posterShow = false;
            setTimeout(function () {
                _this.sideTipShow = true;
            }, 600);
            setTimeout(function () {
                _this.cardShow = true;
            }, 900);
            setTimeout(function () {
                _this.step = 2;
                _this.clickable = true;
            }, 1700);
        }
        else if (this.step == 2) {
            this.clickable = false;
            this.cardShow = false;
            this.sideTipShow = false;
            setTimeout(function () {
                _this.sideTipContent = '没想到，实体店开张后，问题越来越多';
                _this.sideTipShow = true;
                _this.dialogueShow = true;
            }, 500);
            setTimeout(function () {
                _this.sideTipShow = false;
                _this.dialogueShow = false;
            }, 4000);
            setTimeout(function () {
                _this.apiService.ajax({
                    'type': 'post',
                    'url': '/api/pnoStorePoint/' + _this.exerciseId,
                    'data': {
                        'pno_store_point_id': 5
                    }
                }).subscribe(function (result) {
                    _this.problemShow = true;
                });
            }, 4200);
        }
    };
    CasePracticeInfluenceBeginComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
    };
    CasePracticeInfluenceBeginComponent.prototype.goToMain = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/pnoStorePoint/' + this.exerciseId,
            'data': {
                'pno_store_point_id': 10
            }
        }).subscribe(function (result) {
            var link = ['case-practice-influence-main', _this.learningPathId, _this.practiceId, _this.exerciseId];
            var type = null;
            _this.route.queryParams.subscribe(function (queryParams) {
                type = queryParams['type'];
            });
            if (type) {
                _this.router.navigate(link, { queryParams: { type: 'huatek' } });
            }
            else {
                _this.router.navigate(link);
            }
        });
    };
    return CasePracticeInfluenceBeginComponent;
}());
export { CasePracticeInfluenceBeginComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-influence-begin/case-practice-influence-begin.component.ts.pre-build-optimizer.js